/*
 * @Author: Teemo Ding
 * @Date: 2021-11-09 14:50:42
 * @LastEditTime: 2023-03-15 14:31:13
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/Refund/index.tsx
 */
//import RefundCard from '../../../Components/RefundCard';
import {
  Alert,
  Button,
  DropDown,
  Menu,
  MenuItem,
  ModalFooter,
} from '@/src/components/Antd';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { Icon } from '@/src/tools/icon';
import {
  EOperationType,
  EOrderReturnsStatus,
  ETransactionsType,
  OrderRefundTransaction,
} from '@/src/types/common/order';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { useRequest } from 'ahooks';
import { get } from 'lodash';
import React, { Fragment } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { SectionWrapper } from 'src/components/Layouts';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import {
  approveRefundRequest,
  approveReturnRequest,
  cancelReturnComplete,
  manualRefund,
  markReturned,
  onlineRefund,
  onlineRefundNotify,
  rejectRefundRequest,
  rejectReturnRequest,
  returnToRefundConfirmPage,
  viewDetail,
} from 'src/request/order/refund';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { ICategory } from 'src/types/common/template';
import ReturnReject from '../../../Components/ReturnReject';
import ProcessRefund from '../../../Components/SendTemplate';
import { getMaxTimeline } from '../tools';
import RefundDetail from './Components/RefundDetail';
import ReturnDetails from './Components/ReturnDetails';
import css from './css.module.less';
// import { useSelector } from 'react-redux';
// import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';
const PhaseI18NKeyMapping = {
  [EOperationType.Refund]:
    'allOrders.orderDetail.virtualproduct_returndata_refunddropoptions_label',
  [EOperationType.Return]:
    'allOrders.orderDetail.collected_return_category_dropoptions_label',
};

const permissions = () => {
  const canRefundApprove = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderRefund,
        operation: EnumOperation.approve,
      }),
    ],
  });
  const canReturnApprove = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderReturn,
        operation: EnumOperation.approve,
      }),
    ],
  });

  const canRefundReject = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderReturn,
        operation: EnumOperation.reject,
      }),
    ],
  });
  const canReturnReject = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderRefund,
        operation: EnumOperation.reject,
      }),
    ],
  });
  const canProcessRefund = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderRefund,
        operation: EnumOperation.process_refund,
      }),
    ],
  });
  const canMarkAsRefunded = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderRefund,
        operation: EnumOperation.mark_as_refunded,
      }),
    ],
  });
  const canMarkAsReturned = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderReturn,
        operation: EnumOperation.mark_as_returned,
      }),
    ],
  });
  const canConfirmRefund = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderRefund,
        operation: EnumOperation.confirm_refund,
      }),
    ],
  });
  const canCreateEditReturn = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderReturn,
        operation: EnumOperation.create_edit_return,
      }),
    ],
  });
  const canCreateEditRefund = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Order,
        subCategory: EnumSubCategory.OrderRefund,
        operation: EnumOperation.create_edit_refund,
      }),
    ],
  });
  return {
    canRefundApprove,
    canReturnApprove,
    canReturnReject,
    canRefundReject,
    canProcessRefund,
    canMarkAsRefunded,
    canMarkAsReturned,
    canConfirmRefund,
    canCreateEditReturn,
    canCreateEditRefund,
  };
};

const Refund = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  // const storeSettings = useSelector(getBasicSetting());
  // const storeDecimal = get(storeSettings, 'decimalPosition');
  const {
    canRefundApprove,
    canReturnApprove,
    canReturnReject,
    canRefundReject,
    canProcessRefund,
    canMarkAsRefunded,
    canMarkAsReturned,
    canConfirmRefund,
    canCreateEditReturn,
    canCreateEditRefund,
  } = permissions();
  const {
    modalOp,
    currencyCode,
    orderNo,
    orderReturn,
    onUpdate,
    buyerEmail,
    buyerPhoneNo,
    type,
    phase,
    areaCodes,
    buyerAreaCodeInfo,
    buyerMobile,
    key: orderReturnKey,
    salesChannelUuid,
    salesChannelDecimalPosition,
  } = props;
  const {
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
    setWidth,
    // cRef,
  } = modalOp;
  const phaseText = PhaseI18NKeyMapping[phase]
    ? getI18n(PhaseI18NKeyMapping[phase])
    : phase;

  const history = useHistory();
  const { uuid: orderUuid }: any = useParams();
  const {
    totalRefund,
    items,
    returnNo,
    timelines,
    status,
    handleBy,
    refundNo,
    uuid: returnUuid,
    transactions,
    returnLogisticsInfo,
    storeCredit,
  } = orderReturn;

  const { run: _viewDetail } = useRequest(() => viewDetail(returnUuid), {
    manual: true,
    onSuccess(res) {
      const formattedReturnNo = res.formattedReturnNo || '';
      setShowModal(true);
      setWidth(973);
      setModalTitle(
        `${phaseText} ${getI18n(
          `allOrders.orderDetail.refund_viewDetail_modaltitle`,
        )}${formattedReturnNo}`,
      );
      setModalContent(
        phase == EOperationType.Refund ? (
          <RefundDetail
            disabled
            refundDetail={res}
            currencyCode={currencyCode}
            orderUuid={orderUuid}
            onModalCancel={onModalCancel}
            areaCodes={areaCodes}
            orderBuyerEmail={buyerEmail}
            buyerAreaCodeInfo={buyerAreaCodeInfo}
            buyerMobile={buyerMobile}
            decimalPosition={salesChannelDecimalPosition}
            // buyerPhoneNo={buyerPhoneNo}
          />
        ) : (
          <ReturnDetails
            disabled
            returnDetail={orderReturn}
            orderUuid={orderUuid}
            viewDetail
            onUpdate={onUpdate}
            onModalCancel={onModalCancel}
            decimalPosition={salesChannelDecimalPosition}
          />
        ),
      );
    },
  });
  const { run: _approveRequest } = useRequest(
    (phase) =>
      phase === EOperationType.Refund
        ? approveRefundRequest(returnUuid)
        : approveReturnRequest(returnUuid),
    {
      manual: true,
      onSuccess(res) {
        onUpdate(res);
      },
    },
  );
  const { run: _markReturned } = useRequest(() => markReturned(returnUuid), {
    manual: true,
    onSuccess(res) {
      onUpdate(res);
    },
  });
  const { run: _rejectRequest } = useRequest(
    (phase, data) =>
      phase === EOperationType.Refund
        ? rejectRefundRequest({ ...data, uuid: returnUuid })
        : rejectReturnRequest({ ...data, uuid: returnUuid }),
    {
      manual: true,
      onSuccess(res) {
        onUpdate(res);
        onModalCancel(false);
      },
    },
  );
  const { run: _manualRefund, loading: manualRefundLoading } = useRequest(
    (data) => manualRefund(data),
    {
      manual: true,
      onSuccess(res) {
        onUpdate(res);
        onModalCancel(false);
      },
    },
  );

  const { run: _cancelReturnComplete } = useRequest(
    (data) => cancelReturnComplete(data),
    {
      manual: true,
      onSuccess(res) {
        onUpdate(res);
        onModalCancel(false);
      },
    },
  );

  const { run: _returnToRefundConfirmPage } = useRequest(
    () => returnToRefundConfirmPage(returnUuid),
    {
      manual: true,
      onSuccess(res) {
        setShowModal(true);
        setWidth(973);
        setModalTitle(
          `${getI18n(
            `allOrders.orderDetail.refund_returnToRefundConfirmPage_modaltitle`,
          )}${orderNo}-${returnNo}`,
        );
        setModalContent(
          <RefundDetail
            disabled={!canCreateEditRefund}
            refundDetail={res}
            currencyCode={currencyCode}
            orderUuid={orderUuid}
            onUpdate={onUpdate}
            onModalCancel={onModalCancel}
            areaCodes={areaCodes}
            orderBuyerEmail={buyerEmail}
            buyerAreaCodeInfo={buyerAreaCodeInfo}
            buyerMobile={buyerMobile}
            decimalPosition={salesChannelDecimalPosition}
          />,
        );
      },
    },
  );
  const { run: _onlineRefund } = useRequest(
    (orderRefundTransactionUuid) => onlineRefund(orderRefundTransactionUuid),
    {
      manual: true,
      onSuccess(res) {
        onUpdate(res);
        onModalCancel(false);
      },
    },
  );

  const { run: _onlineRefundNotify } = useRequest(
    (data) => onlineRefundNotify(data),
    {
      manual: true,
      onSuccess(res) {
        onUpdate(res);
        onModalCancel(false);
      },
    },
  );

  const handleMarkAsRefunded = (item) => {
    setShowModal(true);
    setWidth(600);
    setModalTitle(getI18n(`allOrders.orderDetail.markasRefunded`));
    setModalContent(
      <ReturnReject
        type='MarkAsRefunde'
        onModalCancel={onModalCancel}
        onSubmit={(data) =>
          _manualRefund({ ...data, orderRefundTransactionUuid: item.uuid })
        }
      />,
    );
  };

  const handleCancelRefundedAll = (cb) => {
    setShowModal(true);
    setWidth(600);
    setModalTitle(
      getI18n(
        'allOrders.orderDetail.refund_handleCancelRefundedAll_modaltitle',
      ),
    );
    setModalContent(
      <ReturnReject
        type='CancelRefund'
        onModalCancel={onModalCancel}
        onSubmit={(data) => cb({ ...orderReturn, ...data })}
      />,
    );
  };

  const overlay = (item) => {
    return !item ? (
      <Menu>
        <MenuItem
          className={css.menuItem}
          onClick={() => {
            setShowModal(true);
            setWidth(973);
            setModalTitle(
              `${phaseText} ${getI18n(
                `allOrders.orderDetail.refund_viewDetail_modaltitle`,
              )}${orderNo}-${refundNo}`,
            );
            setModalContent(
              phase == EOperationType.Refund ? (
                <RefundDetail
                  refundDetail={orderReturn}
                  currencyCode={currencyCode}
                  orderUuid={orderUuid}
                  onUpdate={onUpdate}
                  onModalCancel={onModalCancel}
                  areaCodes={areaCodes}
                  orderBuyerEmail={buyerEmail}
                  buyerAreaCodeInfo={buyerAreaCodeInfo}
                  buyerMobile={buyerMobile}
                  disabled={!canCreateEditRefund}
                  decimalPosition={salesChannelDecimalPosition}
                />
              ) : (
                <ReturnDetails
                  viewDetail={!canCreateEditReturn}
                  returnDetail={orderReturn}
                  orderUuid={orderUuid}
                  onUpdate={onUpdate}
                  onModalCancel={onModalCancel}
                  decimalPosition={salesChannelDecimalPosition}
                />
              ),
            );
          }}>
          {getI18n('general.edit')}
        </MenuItem>
      </Menu>
    ) : (
      <Menu>
        <MenuItem
          className={css.menuItem}
          disabled={!canMarkAsRefunded}
          onClick={() => handleMarkAsRefunded(item)}>
          {getI18n('allOrders.orderDetail.markasRefunded')}
        </MenuItem>
      </Menu>
    );
  };

  const returnedOverlay = (type) =>
    type === EOrderReturnsStatus.ReturnApproved ? (
      <Menu>
        <MenuItem
          className={css.menuItem}
          disabled={!canMarkAsReturned}
          onClick={() => _markReturned()}>
          {getI18n('allOrders.orderDetail.markasReturned')}
        </MenuItem>
      </Menu>
    ) : (
      <Menu>
        <MenuItem
          className={css.menuItem}
          onClick={() => handleCancelRefundedAll(_cancelReturnComplete)}>
          {getI18n(
            'allOrders.orderDetail.refund_handleCancelRefundedAll_modaltitle',
          )}
        </MenuItem>
      </Menu>
    );

  const handleShowReturnDetail = () => {
    setShowModal(true);
    setWidth(973);
    setModalTitle(
      `${getI18n(`allOrders.orderDetail.refund_handleShowReturnDetail`)}${
        orderNo || ''
      }-${returnNo || ''}`,
    );
    setModalContent(
      <ReturnDetails
        disabled
        returnDetail={orderReturn}
        orderUuid={orderUuid}
        onUpdate={onUpdate}
        onModalCancel={onModalCancel}
        decimalPosition={salesChannelDecimalPosition}
      />,
    );
  };

  const handleProcessRefund = (item) => {
    if (item.type === OrderRefundTransaction.NewStoreCredit) {
      setWidth(600);
      setShowModal(true);
      setModalTitle(
        getI18n(
          `allOrders.orderDetail.refund_handleProcessRefund_yes_modaltitle`,
        ),
      );
      setModalContent(
        <ProcessRefund
          buyerEmail={buyerEmail}
          buyerPhoneNo={buyerPhoneNo}
          onModalCancel={onModalCancel}
          salesChannelUuid={salesChannelUuid}
          onConfirm={(data) =>
            _onlineRefundNotify({
              orderRefundTransactionUuid: item.uuid,
              notifyInfo: {
                viaEmail: get(data, 'sendTo', []).includes('Email'),
                viaSms: get(data, 'sendTo', []).includes('Mobile'),
                emailTemplateUuid: get(data, 'emailTemplate'),
                messageTemplateUuid: get(data, 'messageTemplate'),
              },
            })
          }
          category={ICategory.StoreCreditIssued}
          header={
            <Fragment>
              <h3 className={css.title}>
                {getI18n(
                  `allOrders.orderDetail.refund_handleProcessRefund_yes_header_credittitle`,
                )}
              </h3>
              <p>${item.refund}</p>
              <h3 className={css.title}>
                {getI18n(
                  `allOrders.orderDetail.refund_handleProcessRefund_yes_header_Expirationtitle`,
                )}
              </h3>
              <p>
                {get(storeCredit, 'expirationPeriod')}
                {get(storeCredit, 'unit')}
              </p>
            </Fragment>
          }
        />,
      );
    } else {
      setWidth(600);
      setShowModal(true);
      setModalTitle(
        getI18n(
          `allOrders.orderDetail.refund_handleProcessRefund_no_modaltitle`,
        ),
      );
      setModalContent(
        <div>
          <p className={css.refundConfirmation}>
            {getI18n(
              'allOrders.orderDetail.refund_handleProcessRefund_no_modalcontent',
            )}
          </p>
          <ModalFooter
            onCancel={onModalCancel}
            onOk={() => _onlineRefund(item.uuid)}
          />
        </div>,
      );
      //   _onlineRefund(item.uuid);
    }
  };

  const handleReturnReject = () => {
    setWidth(600);
    setShowModal(true);
    setModalTitle(
      `${phaseText} ${getI18n(
        `allOrders.orderDetail.refund_handleReturnReject_modaltitle`,
      )}`,
    );
    setModalContent(
      <ReturnReject
        type={phase}
        onSubmit={(data) => _rejectRequest(phase, data)}
        onModalCancel={onModalCancel}
      />,
    );
  };

  // const timeAll = useMemo(
  //   () => getMaxTimeline(timelines || [], status),
  //   [timelines, status],
  // );
  const checkedItem = items.filter((o) => o.checked || o.customisationChecked);
  const handleViewStoreCreditDetail = (item) => {
    history.push(`/order/giftCard/edit/${item.giftCardUuid}`);
  };

  const handelViewRequest = () => {
    setShowModal(true);
    setWidth(973);
    setModalTitle(
      `${phaseText} ${getI18n(
        `allOrders.orderDetail.refund_viewDetail_modaltitle`,
      )}${orderNo}-${refundNo}`,
    );
    setModalContent(
      phase == EOperationType.Refund ? (
        <RefundDetail
          refundDetail={orderReturn}
          currencyCode={currencyCode}
          orderUuid={orderUuid}
          onUpdate={onUpdate}
          onModalCancel={onModalCancel}
          areaCodes={areaCodes}
          orderBuyerEmail={buyerEmail}
          buyerAreaCodeInfo={buyerAreaCodeInfo}
          buyerMobile={buyerMobile}
          disabled={!canConfirmRefund}
          decimalPosition={salesChannelDecimalPosition}
        />
      ) : (
        <ReturnDetails
          disabled={false}
          viewDetail={!canConfirmRefund}
          returnDetail={orderReturn}
          orderUuid={orderUuid}
          onUpdate={onUpdate}
          onModalCancel={onModalCancel}
          decimalPosition={salesChannelDecimalPosition}
        />
      ),
    );
  };

  return (
    <SectionWrapper
      key={orderReturnKey}
      title={`${phaseText} (${
        phase == EOperationType.Return ? 1 : (transactions || []).length
      } ${getI18n(`allOrders.orderDetail.refund_return_title`)})`}
      containerClassName={css.containerClassName}>
      <div className={css.refundCardTop}>
        <div
          className={
            phase == EOperationType.Return
              ? css.refundCardNoLine
              : css.refundCard
          }>
          <div className={css.refundCardDetail}>
            <h3>
              #{orderNo}-{returnNo} ({checkedItem.length}
              {getI18n('general.items')})
            </h3>
            {status !== EOrderReturnsStatus.ReturnConfirmed &&
              status !== EOrderReturnsStatus.RefundConfirmed &&
              status !== EOrderReturnsStatus.ReturnApproved &&
              status !== EOrderReturnsStatus.Requested && (
                <span onClick={_viewDetail}>
                  {getI18n(`allOrders.orderDetail.refund_return_viewdetails`)}
                </span>
              )}
          </div>
          {(status === EOrderReturnsStatus.ReturnApproved ||
            status === EOrderReturnsStatus.ReturnLogisticsConfirmed) && (
            <div className={css.refundCardButton}>
              {status === EOrderReturnsStatus.ReturnApproved ? (
                <Button type='primary' onClick={handleShowReturnDetail}>
                  {getI18n(
                    `allOrders.orderDetail.refund_return_refundCardButton_ReturnApproved_yes`,
                  )}
                </Button>
              ) : (
                <Button type='primary' onClick={_returnToRefundConfirmPage}>
                  {getI18n(
                    `allOrders.orderDetail.refund_return_refundCardButton_ReturnApproved_no`,
                  )}
                </Button>
              )}
              <DropDown
                overlay={returnedOverlay(status)}
                placement='bottomRight'
                trigger={['click']}>
                <Button
                  icon={<Icon type='iconMore' />}
                  className={css.extendButton}></Button>
              </DropDown>
            </div>
          )}
          {(status === EOrderReturnsStatus.ReturnConfirmed ||
            status === EOrderReturnsStatus.Requested ||
            status === EOrderReturnsStatus.RefundConfirmed) && (
            <div className={css.refundCardButton}>
              {status === EOrderReturnsStatus.Requested ? (
                <Button type='primary' onClick={handelViewRequest}>
                  {getI18n(
                    `allOrders.orderDetail.refund_return_Requested_refundCardButton_yes`,
                  )}
                </Button>
              ) : (
                <Button
                  type='primary'
                  disabled={
                    phase === EOperationType.Return
                      ? !canReturnApprove
                      : !canRefundApprove
                  }
                  onClick={() => _approveRequest(phase)}>
                  {getI18n(
                    `allOrders.orderDetail.refund_return_Requested_refundCardButton_no`,
                  )}
                </Button>
              )}
              <Button
                disabled={
                  phase === EOperationType.Return
                    ? !canReturnReject
                    : !canRefundReject
                }
                onClick={handleReturnReject}>
                {getI18n(
                  `allOrders.orderDetail.refund_return_Requested_handleReturnReject`,
                )}
              </Button>
              {status !== EOrderReturnsStatus.Requested && (
                <DropDown
                  overlay={overlay(null)}
                  placement='bottomRight'
                  trigger={['click']}>
                  <Button
                    icon={<Icon type='iconMore' />}
                    className={css.extendButton}></Button>
                </DropDown>
              )}
            </div>
          )}
        </div>
        {(status === EOrderReturnsStatus.ReturnConfirmed ||
          phase === EOperationType.Return) && (
          <div className={css.refundContain}>
            <div className={css.refundItem}>
              <span>
                {phase === EOperationType.Return
                  ? getI18n(
                      `allOrders.orderDetail.collected_return_category_dropoptions_label`,
                    )
                  : getI18n(
                      `allOrders.orderDetail.refund_return_refundCardButton_ReturnApproved_no`,
                    )}
                {getI18n(
                  `allOrders.orderDetail.refund_return_refundcontain_requested`,
                )}
              </span>
              <span>
                {getMaxTimeline(timelines || [], EOrderReturnsStatus.Requested)}
              </span>
            </div>
            <div className={css.refundItem}>
              {phase == EOperationType.Refund && (
                <Fragment>
                  <span>
                    {getI18n(
                      `allOrders.orderDetail.refund_return_refundcontain_total_refund`,
                    )}
                  </span>
                  <span>
                    ${(totalRefund || 0).toFixed(salesChannelDecimalPosition)}
                  </span>
                </Fragment>
              )}
              {phase == EOperationType.Return &&
                status === EOrderReturnsStatus.ReturnLogisticsConfirmed && (
                  <Fragment>
                    <span>
                      {getI18n(
                        `allOrders.orderDetail.refund_return_deliverycourier`,
                      )}
                    </span>
                    <span>{get(returnLogisticsInfo, 'courier', '')}</span>
                  </Fragment>
                )}
            </div>

            <div className={css.refundItem}>
              {status !== EOrderReturnsStatus.ReturnConfirmed && (
                <Fragment>
                  <span>
                    {phase === EOperationType.Return
                      ? getI18n(
                          `allOrders.orderDetail.collected_return_category_dropoptions_label`,
                        )
                      : getI18n(
                          `allOrders.orderDetail.refund_return_refundCardButton_ReturnApproved_no`,
                        )}
                    {getI18n(
                      `allOrders.orderDetail.refund_return_requestsubmit`,
                    )}
                  </span>
                  <span>
                    {getMaxTimeline(
                      timelines || [],
                      phase == EOperationType.Refund
                        ? EOrderReturnsStatus.RefundConfirmed
                        : EOrderReturnsStatus.ReturnConfirmed,
                    )}
                  </span>
                </Fragment>
              )}
            </div>

            <div className={css.refundItem}>
              {phase == EOperationType.Refund && (
                <Fragment>
                  <span>
                    {getI18n(
                      `allOrders.orderDetail.refund_return_refunditem_handleby`,
                    )}
                  </span>
                  <span>{handleBy}</span>
                </Fragment>
              )}
              {phase == EOperationType.Return &&
                status === EOrderReturnsStatus.ReturnLogisticsConfirmed && (
                  <Fragment>
                    <span>
                      {getI18n(
                        `allOrders.orderDetail.refund_return_refunditem_waybill`,
                      )}
                    </span>
                    <span>{get(returnLogisticsInfo, 'waybillNo', '')}</span>
                  </Fragment>
                )}
            </div>
            <div className={css.refundItem}>
              {type == EOperationType.Return &&
                status === EOrderReturnsStatus.ReturnLogisticsConfirmed && (
                  <Fragment>
                    <span>
                      {getI18n(
                        `allOrders.orderDetail.refund_return_refunditem_deliveryRequest`,
                      )}
                    </span>
                    <span>
                      {getMaxTimeline(
                        timelines || [],
                        EOrderReturnsStatus.ReturnLogisticsConfirmed,
                      )}
                    </span>
                  </Fragment>
                )}
            </div>
            {phase == EOperationType.Return &&
              status === EOrderReturnsStatus.ReturnLogisticsConfirmed && (
                <div className={css.refundItem}></div>
              )}
          </div>
        )}
      </div>
      {(transactions || []).map((item, index) => (
        <div key={index}>
          {item.status == ETransactionsType.Fail && (
            <Alert
              type='error'
              closable
              showIcon
              icon={<Icon type='iconfailed'></Icon>}
              className={css.alert}
              message={getI18n(
                `allOrders.orderDetail.refund_return_refundfail_alert_message`,
              )}
              description={replaceI18nVariables(
                getI18n(
                  `allOrders.orderDetail.refund_return_refundfail_alert_description`,
                ),
                item.errMsg,
              )}
            />
          )}
          <div
            className={
              index > 0 ? css.refundHeaderWidthMargin : css.refundHeader
            }>
            <span className={css.title}>
              {item.type === OrderRefundTransaction.NewStoreCredit
                ? item.type +
                  `${
                    get(item, 'giftCard.redemptionCode')
                      ? '(' + item.giftCard.redemptionCode + ')'
                      : ''
                  }`
                : get(item, 'transactionInfo.paymentMethodName') +
                  ' (' +
                  get(item, 'transactionInfo.provider') +
                  ')'}
            </span>
            {(item.type === OrderRefundTransaction.BankTransfer ||
              item.type === OrderRefundTransaction.FpsQrCode) &&
              item.status === ETransactionsType.Created &&
              status === EOrderReturnsStatus.RefundApproved && (
                <Button
                  type='primary'
                  loading={manualRefundLoading}
                  disabled={!canMarkAsRefunded}
                  onClick={() => handleMarkAsRefunded(item)}>
                  {getI18n(`allOrders.orderDetail.markasRefunded`)}
                </Button>
              )}
            {item.type !== OrderRefundTransaction.BankTransfer &&
              item.type !== OrderRefundTransaction.FpsQrCode &&
              status === EOrderReturnsStatus.RefundApproved && (
                <div>
                  {(item.status == ETransactionsType.Pending ||
                    item.status == ETransactionsType.Created ||
                    item.status == ETransactionsType.Fail) && (
                    <Button
                      type='primary'
                      disabled={
                        item.status == ETransactionsType.Pending ||
                        !canProcessRefund
                      }
                      onClick={() => handleProcessRefund(item)}>
                      {item.status == ETransactionsType.Pending
                        ? 'Processing'
                        : getI18n(
                            `allOrders.orderDetail.refund_handleProcessRefund_yes_modaltitle`,
                          )}
                    </Button>
                  )}

                  {(item.status == ETransactionsType.Created ||
                    item.status == ETransactionsType.Fail) && (
                    <DropDown
                      overlay={overlay(item)}
                      placement='bottomRight'
                      trigger={['click']}>
                      <Button
                        icon={<Icon type='iconMore' />}
                        className={css.extendButton}></Button>
                    </DropDown>
                  )}
                </div>
              )}
          </div>
          {(item.type == OrderRefundTransaction.NewStoreCredit ||
            item.type == OrderRefundTransaction.GiftCard) &&
            item.status == ETransactionsType.Success && (
              <div
                className={css.viewDetail}
                onClick={() => handleViewStoreCreditDetail(item)}>
                {getI18n(
                  `allOrders.orderDetail.refund_return_handleViewStoreCreditDetail`,
                )}
              </div>
            )}
          <div className={css.refundContain}>
            <div className={css.refundItem}>
              <span>
                {phase === EOperationType.Return
                  ? getI18n(
                      `allOrders.orderDetail.collected_return_category_dropoptions_label`,
                    )
                  : getI18n(
                      `allOrders.orderDetail.refund_return_refundCardButton_ReturnApproved_no`,
                    )}
                {getI18n(`allOrders.orderDetail.refund_return_refundrequest`)}
              </span>
              <span>
                {getMaxTimeline(timelines || [], EOrderReturnsStatus.Requested)}
              </span>
            </div>
            <div className={css.refundItem}>
              <span>
                {getI18n(
                  `allOrders.orderDetail.refund_return_refundtotal_Refund`,
                )}
              </span>
              <span>
                ${(item.refund || 0).toFixed(salesChannelDecimalPosition)}
              </span>
            </div>
            <div className={css.refundItem}>
              <span>
                {phase === EOperationType.Return
                  ? getI18n(
                      `allOrders.orderDetail.collected_return_category_dropoptions_label`,
                    )
                  : getI18n(
                      `allOrders.orderDetail.refund_return_refundCardButton_ReturnApproved_no`,
                    )}{' '}
                {getI18n(`allOrders.orderDetail.refund_return_requestsubmit`)}
              </span>
              <span>
                {getMaxTimeline(
                  timelines || [],
                  EOrderReturnsStatus.RefundConfirmed,
                )}
              </span>
            </div>
            <div className={css.refundItem}>
              <span>
                {getI18n(
                  `allOrders.orderDetail.refund_return_refunditem_handleby`,
                )}
              </span>
              <span>{handleBy}</span>
            </div>

            <div className={css.refundItem}>
              <Fragment>
                <span>
                  {phase === EOperationType.Return
                    ? getI18n(
                        `allOrders.orderDetail.collected_return_category_dropoptions_label`,
                      )
                    : getI18n(
                        `allOrders.orderDetail.refund_return_refundCardButton_ReturnApproved_no`,
                      )}
                  {getI18n(
                    `allOrders.orderDetail.refund_return_refundcontain_request_approved`,
                  )}
                </span>
                <span>
                  {getMaxTimeline(
                    timelines || [],
                    EOrderReturnsStatus.RefundApproved,
                  ) || 'pending approval'}
                </span>
              </Fragment>
            </div>

            {get(item, 'transactionInfo.paymentDetail.gatewayReferenceId') && (
              <div className={css.refundItem}>
                <Fragment>
                  <span>
                    {getI18n(
                      'allOrders.orderDetail.refund_return_refundcontain_initial_external_ref',
                    )}
                  </span>
                  <span>
                    {get(
                      item,
                      'transactionInfo.paymentDetail.gatewayReferenceId',
                    )}
                  </span>
                </Fragment>
              </div>
            )}
            {getMaxTimeline(timelines || [], EOrderReturnsStatus.Completed) && (
              <div className={css.refundItem}>
                <span>
                  {' '}
                  {getI18n(
                    'allOrders.orderDetail.refund_return_refundcontain_refunded',
                  )}{' '}
                  {item.manual
                    ? `(${getI18n('general.status.manual')})`
                    : `(${getI18n('general.status.auto')})`}
                </span>
                <span>
                  {getMaxTimeline(
                    timelines || [],
                    EOrderReturnsStatus.Completed,
                  )}
                </span>
              </div>
            )}
            {get(item, 'refundDetails.refundReference') && (
              <div className={css.refundItem}>
                {status == EOrderReturnsStatus.Completed && (
                  <Fragment>
                    <span>
                      {getI18n(
                        'allOrders.orderDetail.refund_return_refundcontain_refund_reference',
                      )}
                    </span>
                    <span>{get(item, 'refundDetails.refundReference')}</span>
                  </Fragment>
                )}
              </div>
            )}
          </div>
        </div>
      ))}
    </SectionWrapper>
  );
};

export default ModalHoc(Refund, { width: 973 });
